var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSccUnspecified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 2,
    fill: "#BDC1C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8803 14.5885H11.4941L11.3862 5.91439H12.9965L12.8803 14.5885ZM11.3281 17.228C11.3281 16.979 11.4028 16.7715 11.5522 16.6055C11.7071 16.434 11.934 16.3482 12.2329 16.3482C12.5317 16.3482 12.7586 16.434 12.9135 16.6055C13.0684 16.7715 13.1459 16.979 13.1459 17.228C13.1459 17.4771 13.0684 17.6846 12.9135 17.8506C12.7586 18.0111 12.5317 18.0913 12.2329 18.0913C11.934 18.0913 11.7071 18.0111 11.5522 17.8506C11.4028 17.6846 11.3281 17.4771 11.3281 17.228Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSccUnspecified);
export default __webpack_public_path__ + "static/media/scc_Unspecified.c3f1504312dfe4d50ae8180cdc8dc046.svg";
export { ForwardRef as ReactComponent };